import BaseView from '../../../base-view';
import ListItemView from '../item/view';

export default BaseView.extend({
	events: {},

	initialize: function() {
		// collection listeners
		this.listenTo(this.collection, 'add', this.onAlertAdded);

		// render list with alerts
		this.renderList();
	},

	/**
	 * Render list with bootstrapped data
	 **/
	renderList: function() {
		// nothing to render
		if (!this.collection.length) {
			return false;
		}

		// loop through collection and insert view
		this.collection.forEach(function(model, index) {
			this.insertView(model, true);
		}, this);
	},

	/**
	 * Create and return a single list item view
	 **/
	createView: function(options) {
		return new ListItemView(options);
	},

	/**
	 * alert added listener
	 * add one item to the list
	 **/
	onAlertAdded: function(model) {
		// insert view
		this.insertView(model);
	},

	/**
	 * Insert view to the list of alerts
	 * A view is appended to the list when isSorted is true, or it's the fist view in the list
	 * Otherwise the position is based on the position of the model in the collection
	 **/
	insertView: function(model, isSorted) {
		var listItem = this.createView({model: model}).render(),
			index,
			insertBeforeEl;

		// first item or sorted, append to list and return
		if (this.el.children.length === 0 || isSorted) {
			this.el.appendChild(listItem.el);
			return listItem;
		}

		// find index to insert view at
		index = this.collection.indexOf(model);
		insertBeforeEl = this.el.children[index];

		this.el.insertBefore(listItem.el, insertBeforeEl);

		return listItem;
	}
});

